const data = {
  components: {
    logo: {
      text: "AS",
    },
    contact: {
      email: "asemagn@gmail.com",
      linkedin: "https://linkedin.com/in/addissemagn",
      github: "https://github.com/addissemagn",
      twitter: "https://twitter.com/addissemagn",
    },
    nav: [{
        name: "Work",
        link: "/#experiences",
      },
      {
        name: "About",
        link: "/#about",
      },
      {
        name: "Projects",
        link: "/projects",
      },
      {
        name: "Resume",
        link: "/resume",
      },
    ],
    // class 'sr-only' is only visible for screen-readers
    footer: "made by addis <a class='no-decor' href='https://github.com/addissemagn/addis.world'><span class='sr-only'>GitHub repository</span><i class='fab fa-github'></i></a>, <br /> listening to <a href='https://open.spotify.com/playlist/0cF1p8yQopiQTNN6HktvOt?si=daecec02b0e54e09'><span class='sr-only'>Spotify playlist</span>♫</a>",
  },
};

export default data;